
<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <br /><br />
          <div class="text-center">
            <img
              src="../../assets/img/mobileuser.png"
              style="max-width: 100%"
            />
          </div>

          <div class="card-custom-web">
            <br />
            <br />
            <div class="text-center">
            <h5 class="text-center mt-4">
              <strong>Your QR Code</strong>
            </h5>
            <canvas ref="canvas"></canvas>
          </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Referral Code</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>
  
  <script>
import QRCode from "qrcode";
export default {
  data: function () {
    return {
      messagebtn: "",
      user: {},
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
      this.text = this.user.codeSecret; // Set the value of text
      this.generateQRCode(); // Auto generate QR code
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GoToRegStudParent() {
      this.$router.push("/RegisterStudentParent");
    },
    GoToRegStud() {
      this.$router.push("/RegisterStudentGrade");
    },
    GoBack() {
      this.$router.back();
    },
    GoToApp() {
      const myParamValue = this.extractString;
      const encodedParamValue = encodeURIComponent(myParamValue);

      window.open(
        `whatsapp://send?text=Check out this code referral ` +
          this.user.codeSecret
      );
    },
    GoToWebs() {
      var linkshares = this.linkShare;
      window.open(
        `https://web.whatsapp.com/send?text=Check out this code referral ` +
          this.user.codeSecret
      );
    },
    copyLink() {
      this.messagebtn = "Copied";
      navigator.clipboard.writeText(this.user.codeSecret);
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.generateQRCode(this.user.codeSecret);
          }
        });
    },
    generateQRCode(codeSecret) {
      const canvas = this.$refs.canvas;
      QRCode.toCanvas(canvas, codeSecret, { errorCorrectionLevel: "H" }, function (error) {
        if (error) console.error(error);
      });
    },
  },
};
</script>

  
  <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}
.ctabs {
  /* Add styles to the parent container if needed */
}
.card-custom-web {
  max-width: 700px;
  left: 0px;
  height: 100vh;
  margin-top: 50px;
  background: #f9f9f9;
  -webkit-box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 32px 0px 0px 0px;
  color: #000;
}

.ctab {
  border-bottom: 2px solid transparent; /* Set a transparent bottom border for all tabs */
  padding-bottom: 10px; /* Adjust the padding as needed */
}

.ctab.active {
  border-color: #000; /* Set the bottom border color for the active tab */
}
@media only screen and (max-width: 768px) {
  #whatsapp-mobile {
    display: block;
    width: 100% !important;
  }
  #whatsapp-desktop {
    display: none;
  }
}
@media only screen and (min-width: 769px) {
  #whatsapp-mobile {
    display: none;
  }
  #whatsapp-desktop {
    display: block;
    width: 100% !important;
  }
}
</style>